enum IllustratedProcedureType {
    MATERIALS = 'MATERIALS',
    TECHNICIAN = 'TECHNICIAN',
    GENERAL = 'GENERAL',
    COMPLEMENT = 'COMPLEMENT'
}

export default IllustratedProcedureType;
